import React from 'react';
import { LayoutGrid, Globe, Crosshair, Link2, Users } from 'lucide-react';

const nav = [
  { icon: LayoutGrid, label: 'Overview' },
  { icon: Globe, label: 'Attack Surface' },
  { icon: Crosshair, label: 'Vulnerabilities', active: true },
  { icon: Link2, label: 'Compliance' },
  { icon: Users, label: 'Agents' },
];

const severities = ['#FF3B3B', '#FF9900', '#FFD700', '#B6FF3C', '#B6FF3C'];

export const DashboardMockup = () => (
  <div className="mock" data-testid="dashboard-mockup">
    <aside className="mock-sidebar">
      {nav.map(({ icon: Icon, label, active }) => (
        <div key={label} className={`mock-nav-item${active ? ' is-active' : ''}`}>
          <Icon size={14} />
          <span className="mono-label">{label}</span>
        </div>
      ))}
    </aside>

    <div className="mock-main">
      <div className="mock-chips">
        {severities.slice(0, 4).map((c, i) => (
          <div className="mock-chip" key={i}>
            <span className="mock-dot" style={{ background: c }} />
            <span className="mock-bar" style={{ width: 60 }} />
          </div>
        ))}
      </div>

      <div className="mock-panels">
        <div className="mock-panel">
          <div className="mock-panel-head">
            <span className="mock-dot" style={{ background: '#B6FF3C' }} />
            <span className="mono-label mock-panel-title">Unauthenticated Remote Code Execution</span>
          </div>
          <span className="mock-bar" style={{ width: '92%' }} />
          <span className="mock-bar" style={{ width: '84%' }} />
          <span className="mock-bar" style={{ width: '70%' }} />
          <div className="mock-inset">
            <span className="mock-bar" style={{ width: '48%' }} />
            <span className="mock-bar" style={{ width: '66%' }} />
            <span className="mock-bar" style={{ width: '38%' }} />
          </div>
        </div>

        <div className="mock-side">
          <div className="mock-panel mock-panel-sm">
            {[0, 1, 2, 3].map((i) => (
              <div className="mock-row" key={i}>
                <span className="mock-bar" style={{ width: 54 }} />
                <span className="mock-bar" style={{ width: 78 }} />
              </div>
            ))}
          </div>
          <div className="mock-panel mock-panel-sm">
            <span className="mock-bar" style={{ width: '80%' }} />
            <span className="mock-bar" style={{ width: '64%' }} />
            <span className="mock-bar" style={{ width: '72%' }} />
          </div>
        </div>
      </div>

      <div className="mock-table">
        {severities.map((c, i) => (
          <div className="mock-table-row" key={i}>
            <span className="mock-dot" style={{ background: c }} />
            <span className="mock-bar" style={{ width: '22%' }} />
            <span className="mock-bar" style={{ width: '14%' }} />
            <span className="mock-bar" style={{ width: '14%' }} />
            <span className="mock-bar" style={{ width: '18%' }} />
          </div>
        ))}
      </div>
    </div>
  </div>
);
